/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetSpendBreakdown } from "../funcs/usageGetSpendBreakdown.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SpendBreakdownResponse } from "../models/components/spendbreakdownresponse.js";
import {
  GetSpendBreakdownRequest,
  GetSpendBreakdownSecurity,
} from "../models/operations/getspendbreakdown.js";
import { unwrapAsync } from "../types/fp.js";
export type GetSpendBreakdownQueryData = SpendBreakdownResponse;

export function prefetchGetSpendBreakdown(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetSpendBreakdownRequest | undefined,
  security?: GetSpendBreakdownSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetSpendBreakdownQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetSpendBreakdownQuery(
  client$: GramCore,
  request?: GetSpendBreakdownRequest | undefined,
  security?: GetSpendBreakdownSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetSpendBreakdownQueryData>;
} {
  return {
    queryKey: queryKeyGetSpendBreakdown({
      from: request?.from,
      to: request?.to,
      gramSession: request?.gramSession,
    }),
    queryFn: async function getSpendBreakdownQueryFn(
      ctx,
    ): Promise<GetSpendBreakdownQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetSpendBreakdown(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetSpendBreakdown(
  parameters: {
    from?: Date | undefined;
    to?: Date | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "usage", "getSpendBreakdown", parameters];
}
